const placeholders = {
    Task: {
        "{TaskName}": { description: "Task name", type: "both" },
        "{TaskType}": { description: "Task type", type: "both" },
        "{TaskURL}": { description: "Task url", type: "both" },
        "{PersonnelList}": { description: "Personnel list", type: "both" },
        "{Actioner}": { description: "Actioner", type: "both" },
        "{CreationDate}": { description: "CreationDate", type: "both" },
        "{CompletionDate}": { description: "CompletionDate", type: "completion" },
        "{DeletionDate}": { description: "DeletionDate", type: "deletion" },
        "{DueDate}": { description: "Due Date", type: "both" },
        "{Location}": { description: "Location", type: "both" },
        "{RecursiveInfoIfRecursive}": { description: "Recursive Info (If Recursive)", type: "both" },
    },
};

export const TaskCompletionPlaceholders = Object.entries(placeholders.Task)
    .filter(([key, value]) => value.type === "both" || value.type === "completion")
    .reduce((obj, [key, value]) => {
        obj[key] = value.description;
        return obj;
    }, {} as { [key: string]: string });

export const TaskDeletionPlaceholders = Object.entries(placeholders.Task)
    .filter(([key, value]) => value.type === "both" || value.type === "deletion")
    .reduce((obj, [key, value]) => {
        obj[key] = value.description;
        return obj;
    }, {} as { [key: string]: string });

export const TaskCreationPlaceholders = Object.entries(placeholders.Task)
    .filter(([key, value]) => value.type === "both")
    .reduce((obj, [key, value]) => {
        obj[key] = value.description;
        return obj;
    }, {} as { [key: string]: string });
